import template from './modalRejectRequest.html';
import controller from './modalRejectRequest.controller';
import './modalRejectRequest.scss';

let modalRejectRequestComponent = {
  restrict: 'E',
  bindings: {
    request: '<',
    month:'<',
    setAction:'&',
    isMobileApp: '<',
  },
  template,
  controller
};

export default modalRejectRequestComponent;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/benefitRequestModal/modalRejectRequest/modalRejectRequest.component.js